import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AlertController, ModalController, NavController, NavParams, LoadingController, ToastController } from '@ionic/angular';

import { Stylist } from '../../models/stylist/stylist.model';
import { StylistService } from '../../services/stylist.service';
import { UserService } from '../../services/user.service';
import { CustomValidator } from '../../utilities/custom-validator';
import { Utilities } from '../../utilities/utilities';
import { StylistEmailChecker } from '../../utilities/stylist-email-checker';
import { List } from 'immutable';
import { Router } from '@angular/router';
import { Input } from '@angular/core';

@Component({
  selector: 'app-stylist-create',
  templateUrl: './stylist-create.page.html',
  styleUrls: ['./stylist-create.page.scss'],
})
export class StylistCreatePage implements OnInit {


  public submitAttempt: boolean;

  public stylist: Stylist;

  public stylistProfileForm: UntypedFormGroup;

  public firstName: UntypedFormControl;
  public lastName: UntypedFormControl;
  public title: UntypedFormControl;
  public email: UntypedFormControl;
  public pronouns: UntypedFormControl;
  public customPronouns: UntypedFormControl;
  public active: UntypedFormControl;

  public administrator: UntypedFormControl;

  public hasCalendar: UntypedFormControl;

  public canEditOwnSettings: UntypedFormControl;

  public canViewAllClients: UntypedFormControl;

  public canViewAllStaffCalendars: UntypedFormControl;

  public canViewAllReports: UntypedFormControl;

  public canReceivePushNotificaitons: UntypedFormControl;
  public pronounOptions: List<{ name: string; value: number }>;
  @Input() sortVal: number;


  constructor(private navCtrl: NavController,
    private navParams: NavParams,
    private alertCtrl: AlertController,
    private stylistService: StylistService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private toastCrtl: ToastController,
    private stylistEmailChecker: StylistEmailChecker,
    //private viewController: ViewController
    private router: Router,
  ) {


    // pass 0 for stylist ID because we don't have a stylist yet, we're creating a new one
    this.pronounOptions = List.of(
      {
        name: 'Please select',
        value: 0
      },
      {
        name: 'She/Her',
        value: 1
      },
      {
        name: 'He/Him',
        value: 2
      },
      {
        name: 'They/Them',
        value: 3
      },
      {
        name: 'Custom',
        value: 4
      }
    );
    this.stylistService.setEmailCheckerStylistID(0);

    this.stylist = this.initStylist();

    this.submitAttempt = false;
    this.firstName = new UntypedFormControl(this.stylist.getFirstName(), Validators.compose([Validators.required, Validators.maxLength(30)]));
    this.lastName = new UntypedFormControl(this.stylist.getLastName(), Validators.compose([Validators.maxLength(35)]));
    this.title = new UntypedFormControl(this.stylist.getTitle(), Validators.compose([Validators.maxLength(35)]));
    this.email = new UntypedFormControl(this.stylist.getEmail(), Validators.compose([Validators.required, Validators.maxLength(100), CustomValidator.validateEmail]), this.stylistEmailChecker.stylistEmailAvailabilityChecker());
    this.active = new UntypedFormControl(this.stylist.isActive());
    this.administrator = new UntypedFormControl(this.stylist.isAdministrator());
    this.hasCalendar = new UntypedFormControl(this.stylist.getCalendar() === 1 ? true : false);
    this.canEditOwnSettings = new UntypedFormControl(this.stylist.getSettingsControl() === 1 ? true : false);
    this.canViewAllClients = new UntypedFormControl(this.stylist.getViewAllClients() === 1 ? true : false);
    this.canViewAllStaffCalendars = new UntypedFormControl(this.stylist.getViewAllCalendars() === 1 ? true : false);
    this.canViewAllReports = new UntypedFormControl(this.stylist.getCanViewReports() === 1 ? true : false);
    this.canReceivePushNotificaitons = new UntypedFormControl(this.stylist.getCanPush() === 1 ? true : false);
    this.pronouns = new UntypedFormControl(this.stylist.getPronoun() ? this.stylist.getPronoun() : '0');
    this.customPronouns = new UntypedFormControl(
      this.stylist.getCustomPronoun(),
      Validators.maxLength(35)
    );
    this.stylistProfileForm = this.formBuilder.group({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      active: this.active,
      administrator: this.administrator,
      hasCalendar: this.hasCalendar,
      canEditOwnSettings: this.canEditOwnSettings,
      canViewAllClients: this.canViewAllClients,
      canViewAllStaffCalendars: this.canViewAllStaffCalendars,
      canViewAllReports: this.canViewAllReports,
      canReceivePushNotificaitons: this.canReceivePushNotificaitons,
      pronouns: this.pronouns,
      customPronouns: this.customPronouns,
    });

  }

  public ngOnInit() { }

  public initStylist(): Stylist {
    return new Stylist({
      id: undefined,
      firstName: '',
      lastName: '',
      title: '',
      email: '',
      phone1: '',
      phone2: '',
      address1: '',
      address2: '',
      city: '',
      province: '',
      postal: '',
      country: this.userService.getSalon().getCountry(),
      active: 1,
      administrator: 0,
      isRebook: 1,
      suggestRebookingBeforeCheckout: 0,
      stylistKey: '',
      confirmApptsManually: 0,
      calendar: 1,
      viewAllCalendars: 1,
      viewAllClients: 1,
      photoUrl: '',
      hideDurations: 0,
      canPush: 1,
      settingsControl: 1,
      canViewReports: 0,
      cc: 1,
      allowBookingsUntil: '24',
      bookingHorizon: '180',
      sendAppointmentReminderBefore: 24,
      bookingInterval: 15,
      letClientsRegister: 1,
      letClientsCancel: 1,
      bookingIntro: '',
      notifyForAllStaffActivity: 0,
      newBookingNotification: 1,
      editBookingNotification: 1,
      deleteBookingNotification: 1,
      waitListRequestNotification: 1,
      intercomUserHash: '',
      abTest: 1,
      fbID: '',
      cancellationPolicy: '',
      waitingList: 1,
      allowCancellationUntil: '',
      letClientsUseFBLogin: 1,
      minCancellation: '24',
      sort: null,
      pronoun: null,
      customPronoun: null,
      isChatboxEnabled: true,
      isChatBubbleEnabled: true,
    });
  }

  public async onStylistFormSave() {
    this.submitAttempt = true;
    if (this.stylistProfileForm.valid === false) {
      return;
    }

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.stylist = this.stylist.setFirstName(this.firstName.value);
    this.stylist = this.stylist.setLastName(this.lastName.value);
    this.stylist = this.stylist.setTitle(this.title.value);
    this.stylist = this.stylist.setEmail(this.email.value);
    this.stylist = this.stylist.setActive(this.active.value ? 1 : 0);
    this.stylist = this.stylist.setadministrator(this.administrator.value);
    this.stylist = this.stylist.setCalendar(this.hasCalendar.value ? 1 : 0);
    this.stylist = this.stylist.setSettingsControl(this.canEditOwnSettings.value ? 1 : 0);
    this.stylist = this.stylist.setViewAllClients(this.canViewAllClients.value ? 1 : 0);
    this.stylist = this.stylist.setViewAllCalendars(this.canViewAllStaffCalendars.value ? 1 : 0);
    this.stylist = this.stylist.setCanViewReports(this.canViewAllReports.value ? 1 : 0);
    this.stylist = this.stylist.setCanPush(this.canReceivePushNotificaitons.value ? 1 : 0);
    this.stylist = this.stylist.setPronoun(this.pronouns.value);
    this.stylist = this.stylist.setCustomPronoun(this.customPronouns.value);
    this.stylist = this.stylist.setSort(this.sortVal);
    this.stylistService.saveStylist(this.stylist)
      .subscribe({
        next:
          stylist => {
            this.stylistService.updateStylist(this.stylist);
            this.stylistService.setOutdated();
            loader.dismiss().then(async () => {
              this.modalCtrl.dismiss(stylist);
              const toast = await this.toastCrtl.create({
                message: `You've successfully added a new staff member. ${stylist.getFirstName()} will receive a welcome email with their temporary password.`,
                duration: 5000,
                position: 'bottom'
                // showCloseButton: true
              });
              toast.present();
            });
          },
        error: (e) => {
          loader.dismiss().then(async () => {
            var alert = await this.alertCtrl.create(Utilities.getDefaultErrorMessageConfig());
            await alert.present();
          });
        }
      });
  }

  public onDismiss() {
    this.modalCtrl.dismiss();

  }


}
